// import React from "react";
// import styles from "../../asset/Clients/Clients.module.scss";
// import WhoWeAreImage from "../../asset/images/img1.png"


// const clientLogos = [
//     { id: 1, src:WhoWeAreImage, alt: "New Era" },
//     { id: 2, src: WhoWeAreImage, alt: "Colosseum" },
//     { id: 3, src:WhoWeAreImage, alt: "Avery Dennison" },
//     { id: 4, src: WhoWeAreImage, alt: "Ouray" },
//     { id: 5, src:WhoWeAreImage, alt: "Hanes" },
//     { id: 6, src: WhoWeAreImage, alt: "Dyehard" },
//     { id: 7, src:WhoWeAreImage, alt: "Summit" },
//     { id: 8, src: WhoWeAreImage, alt: "Uniform Advantage" },
//     { id: 9, src:WhoWeAreImage, alt: "5th & Ocean" },
//     { id: 10, src: WhoWeAreImage, alt: "Antigua" },
//     { id: 11, src:WhoWeAreImage, alt: "5th & Ocean" },
//     { id: 12, src: WhoWeAreImage, alt: "Antigua" },

// ];

// const ClientsHome = () => {
//     return (
//         <section className={styles.clientsSection}>
//             <div className={styles.container}>
//                 <h2 className={styles.title}>Our Trusted Clients</h2>
//                 <div className={styles.grid}>
//                     {clientLogos.map((logo) => (
//                         <div key={logo.id} className={styles.logoCard}>
//                             <img src={logo.src} alt={logo.alt} />
//                         </div>
//                     ))}
//                 </div>
//             </div>
//         </section>
//     );
// };

// export default ClientsHome;

import React from 'react'
import Affiliations from '../Affiliations/Affiliations'

const ClientsHome = () => {
  return (
    <div>
      <Affiliations />

    </div>
  )
}

export default ClientsHome
